




























































































































import { Component, Vue } from 'vue-property-decorator'
import yoy from './components/yoy.vue'
import moment from 'moment'
const echarts = require('echarts')
import {
  getcarbonEmission,
  getcarbonEmissionTrend,
} from '@/api/enerySupervision'
import NoData from '@/components/NoData'
@Component({
  components: {
    yoy,
    NoData,
  },
})
export default class Login extends Vue {
  private month: any = '00';
  private year: any = moment(new Date().getFullYear(), 'YYYY');
  private yearShowOne: boolean = false;
  private tiemDefaultValue: string = '全年';
  private timeArr: any[] = [
    { value: '全年', id: `00` },
    { value: '一月', id: `01` },
    { value: '二月', id: `02` },
    { value: '三月', id: `03` },
    { value: '四月', id: `04` },
    { value: '五月', id: `05` },
    { value: '六月', id: `06` },
    { value: '七月', id: `07` },
    { value: '八月', id: `08` },
    { value: '九月', id: `09` },
    { value: '十月', id: `10` },
    { value: '十一月', id: `11` },
    { value: '十二月', id: `12` },
  ];
  private dataList: any = null;
  private dataCOList: any = null;
  private dataListBar: any = null;
  private isshowdataListBar: Boolean = false;
  private isshowdataListBarpie: Boolean = false;
  private isshowdataListBarpieCO: Boolean = false;
  private isshowdataListBarCO: Boolean = false;
  private dataListBarCarborn: any = null;
  private unitType: number = 0;
  private action: string = 'view';
  private code: any = null;
  private CarbonEmissionshow = false;
  private CarbonEmissionCOshow = false;
  private riseObj: any = {
    aboveNumber: 0,
    belowNumber: 0,
    rise: 0,
    riseRate: 0,
    aboveDate: 0,
    belowDate: 0,
  };
  private riseObjCO: any = {
    aboveNumber: 0,
    belowNumber: 0,
    rise: 0,
    riseRate: 0,
    aboveDate: 0,
    belowDate: 0,
  };
  private color: any[] = [
    [
      { offset: 1, color: '#d2e8fe' },
      { offset: 0.5, color: '#7ebcfd' },
      { offset: 0, color: '#3596fb' },
    ],
    [
      { offset: 1, color: '#def7ff' },
      { offset: 0.5, color: '#a2e7fe' },
      { offset: 0, color: '#65d8fd' },
    ],
    [
      { offset: 1, color: '#D7E9D8' },
      { offset: 0.5, color: '#3EDA6A' },
      { offset: 0, color: '#57da57' },
    ],
    [
      { offset: 1, color: '#d2e8fe' },
      { offset: 0.5, color: '#7ebcfd' },
      { offset: 0, color: '#73c0de' },
    ],
    [
      { offset: 1, color: '#ee6666' },
      { offset: 0.5, color: '#ee6666' },
      { offset: 0, color: '#3596fb' },
    ],
        [
      { offset: 1, color: '#73c0de' },
      { offset: 0.5, color: '#3ba272' },
      { offset: 0, color: '#3ba272' },
    ],
        [
      { offset: 1, color: '#d2e8fe' },
      { offset: 0.5, color: '#fac858' },
      { offset: 0, color: '#fac858' },
    ]

  ];
  // 弹出日历和关闭日历的回调
  openChangeOne(status: any) {
    if (status) {
      this.yearShowOne = true
    } else {
      this.yearShowOne = false
    }
  }
  // 选择月份
  handleChange(value: any) {
    this.month = value
    if (moment(this.year).format('YYYY') == 'Invalid date') {
      this.$message.error('年份不能为空')
    } else if (value == '00') {
      this.riseObj.aboveDate = `${moment(this.year).format('YYYY')}`
      this.riseObj.belowDate = `${
        Number(moment(this.year).format('YYYY')) - 1
      }`
      this.riseObjCO.aboveDate = `${moment(this.year).format('YYYY')}`
      this.riseObjCO.belowDate = `${
        Number(moment(this.year).format('YYYY')) - 1
      }`
      const params = {
        enterpriseCode: this.code,
        statDate: this.riseObj.aboveDate,
        emissionType: 0,
      }
      this.init(params)
    } else {
      this.riseObj.aboveDate = `${moment(this.year).format('YYYY')}-${value}`
      this.riseObj.belowDate = `${
        Number(moment(this.year).format('YYYY')) - 1
      }-${value}`
      this.riseObjCO.aboveDate = `${moment(this.year).format('YYYY')}-${value}`
      this.riseObjCO.belowDate = `${
        Number(moment(this.year).format('YYYY')) - 1
      }-${value}`
      const params = {
        enterpriseCode: this.code,
        statDate: this.riseObj.aboveDate,
        emissionType: 0,
      }
      this.init(params)
    }
  }
  // 得到年份选择器的值
  onYearChange(value: any) {
    this.year = moment(value).format('YYYY')
    if (this.month == '00') {
      this.riseObj.aboveDate = this.year
      this.riseObjCO.aboveDate = this.year
      this.riseObj.belowDate = String(this.year - 1)
      this.riseObjCO.belowDate = String(this.year - 1)
    } else {
      this.riseObj.aboveDate = `${this.year}-${this.month}`
      this.riseObjCO.aboveDate = `${this.year}-${this.month}`
      this.riseObj.belowDate = `${this.year - 1}-${this.month}`
      this.riseObjCO.belowDate = `${this.year - 1}-${this.month}`
    }
    const params = {
      enterpriseCode: this.code,
      statDate: this.riseObj.aboveDate,
      emissionType: 0,
    }
    this.init(params)
    this.yearShowOne = false
    // this.getUtilizationList(this.$route.query.encode,this.year)
  }
  init(params: any) {
    this.getConsumTrend(params)
    this.getcarbonEmissionTrendRequest(params)
  }
  private consumptionData: any = [];
  private consumptionDataSum: any = 0;
  private consumptionDataSumCO: any = 0;
  private consumptionDataCO: any = null;
  async getConsumTrend(params: any) {
    const that = this
    const { status, data } = await getcarbonEmission(params)
    if (!data) {
      this.riseObj.aboveNumber = 0
      this.riseObj.belowNumber = 0
      this.riseObj.rise = 0
      this.riseObj.riseRate = 0
    }
    if (status == 0 && data) {
      this.dataList = data
      this.riseObj.aboveNumber = data.aboveNumber
      this.riseObj.belowNumber = data.belowNumber
      this.riseObj.rise = data.rise
      this.riseObj.riseRate = data.riseRate
      this.consumptionDataSum = data.aboveNumber
      if (data.carbonList.length > 0) {
        this.isshowdataListBarpie = true
        this.consumptionData = data.carbonList.map((ele: any) => {
          return {
            value: (ele.ratio * 100).toFixed(2),
            dataValue:ele.dataValue,
            name: ele.energyName,
          }
        })
      } else {
        this.consumptionData = []
        this.isshowdataListBarpie = false
      }
      this.CarbonEmissionshow = true
    }

    params.emissionType = 1
    const datas = await getcarbonEmission(params)
    if (!datas) {
      this.riseObjCO.aboveNumber = 0
      this.riseObjCO.belowNumber = 0
      this.riseObjCO.rise = 0
      this.riseObjCO.riseRate = 0
    }
    if (status == 0 && datas.data) {
      this.dataCOList = datas.data
      this.riseObjCO.aboveNumber = this.dataCOList.aboveNumber
      this.riseObjCO.belowNumber = this.dataCOList.belowNumber
      this.riseObjCO.rise = this.dataCOList.rise
      this.riseObjCO.riseRate = this.dataCOList.riseRate
      this.consumptionDataSumCO = datas.data.aboveNumber
      if (this.dataCOList.carbonList.length > 0) {
        this.isshowdataListBarpieCO = true
        this.consumptionDataCO = this.dataCOList.carbonList.map((ele: any) => {
          return {
            value: (ele.ratio * 100).toFixed(2),
            dataValue:ele.dataValue,
            name: ele.energyName,
          }
        })
      } else {
        this.consumptionDataCO = []
        this.isshowdataListBarpieCO = false
      }

      this.CarbonEmissionCOshow = true
    }
    setTimeout(function () {
      that.handleEharts()
      that.initConsumption(that.consumptionData, that.consumptionDataSum)
      that.initConsumptionCO(that.consumptionDataCO, that.consumptionDataSumCO)
    }, 300)
  }
  async getcarbonEmissionTrendRequest(params: any) {
    const that = this
    const { status, data } = await getcarbonEmissionTrend(params)
    if (status == 0 && data) {
      if (data.trendDataList.length > 0) {
        this.dataListBar = data
      } else {
        this.dataListBar = []
      }
    }

    params.emissionType = 1
    const datas = await getcarbonEmissionTrend(params)
    if (datas.status == 0 && datas.data) {
      this.dataListBarCarborn = datas.data
    }

    setTimeout(function () {
      that.handleEharts()
      that.initConsumption(that.consumptionData, that.consumptionDataSum)
      that.initConsumptionCO(that.consumptionDataCO, that.consumptionDataSumCO)
    }, 500)
  }
  handleEharts() {
    //碳排放量
    if (this.dataListBar.trendDataList) {
      this.dataListBar.trendDataList.forEach((ele: any, index: number) => {
        const dataX: any = []
        const dataY: any = []
        let seriesY: any = []
        seriesY = this.dataListBar.trendDataList.map((e: any, i: number) => {
          return {
            name: this.dataListBar.energyNameList[i],
            data: this.dataListBar.trendDataList[i],
            type: 'bar',
            stack: '碳排放量',
            barWidth : 15,//柱图宽度
            // itemStyle: {
            //   normal: {
            //     color: new echarts.graphic.LinearGradient(
            //       0,
            //       0,
            //       0,
            //       1,
            //       this.color[i]
            //     ),
            //   },
            // },
          }
        })
        ele.forEach((out: any, ind: number) => {
          dataX.push(this.dataListBar.timeList[ind])
        })
        // this.initConsumption(this.consumptionData,this.consumptionDataSum)
        this.initConsumptionBar(dataX, seriesY, 1)
      })
    } else {
      this.initConsumptionBar([], [], 1)
      // this.initConsumption(this.consumptionData,this.consumptionDataSum)
    }

    //二氧化碳排放量
    if (this.dataListBarCarborn.trendDataList.length > 0) {
      this.dataListBarCarborn.trendDataList.forEach(
        (ele: any, index: number) => {
          const dataX: any = []
          const dataY: any = []
          let seriesY: any = []
          seriesY = this.dataListBarCarborn.trendDataList.map(
            (e: any, i: number) => {
              return {
                name: this.dataListBarCarborn.energyNameList[i],
                data: this.dataListBarCarborn.trendDataList[i],
                type: 'bar',
                stack: '二氧化碳排放量',
                barWidth : 15,//柱图宽度
                // itemStyle: {
                //   normal: {
                //     color: new echarts.graphic.LinearGradient(
                //       0,
                //       0,
                //       0,
                //       1,
                //       this.color[i]
                //     ),
                //   },
                // },
              }
            }
          )

          ele.forEach((out: any, ind: number) => {
            dataX.push(this.dataListBarCarborn.timeList[ind])
          })
          this.initConsumptionBarCarborn(dataX, seriesY, 1)
          // this.initConsumptionCO(this.consumptionDataCO,this.consumptionDataSumCO)
        }
      )
    } else {
      this.initConsumptionBarCarborn([], [], 1)
      // this.initConsumptionCO(this.consumptionDataCO,this.consumptionDataSumCO)
    }
  }
  //碳排放概括和环形图
  initConsumption(dataY: any, id: number) {
    if (dataY.length > 0) {
      setTimeout(function () {
        const main: any = document.getElementById('carbonEmission')
        main.removeAttribute('_echarts_instance_')
        // 基于准备好的dom，初始化echarts实例
        const consumptionEchart: any = echarts.init(main as HTMLDivElement)
        // 指定图表的配置项和数据
        const option = {
          title: {
            show: true,
            text: '全部',
            subtext: id,
            top: '41%',
            left: '49%',
            textAlign: 'center',
            textStyle: {
              fontSize: '12',
              fontWeight: 'bold',
            },
            subtextStyle: {
              fontSize: '12',
              fontWeight: 'bold',
            },
          },
          tooltip: {
            show: true,
            trigger: 'item',
            // formatter: '{a} <br/>{b}:({d}%)',
            formatter:function(data:any){
              return data.name + '<br/>'+ data.name+ ' : ' + data.data.dataValue + ' ('+data.percent.toFixed(1)+'%)'
            }
          },
          legend: {
            bottom: -5,
            left: 'center',
          },
          series: [
            {
              name: '碳排放量',
              type: 'pie',
              radius: ['35%', '50%'],
              itemStyle: {
                normal: {
                  label: {
                    //此处为指示线文字
                    show: true,
                    // position: 'inner', //标签的位置
                    textStyle: {
                      fontWeight: 200,
                      fontSize: 13, //文字的字体大小
                    },
                    formatter: function (p: any) {
                      //指示线对应文字
                      return p.name.length>1?p.name.substr(0,1)+'...':p.name + Number(p.percent).toFixed(2) + '%'
                    },
                  },
                  labelLine: {
                    //指示线状态
                    show: true,
                    smooth: 0.2,
                    length: 10,
                  },
                },
              },
              avoidLabelOverlap: false,
              label: {
                show: false,
                position: 'center',
              },
              emphasis: {
                label: {
                  show: true,
                  // fontSize: '10',
                  // fontWeight: 'bold'
                },
              },
              labelLine: {
                show: false,
              },
              data: dataY,
            },
          ],
        }
        // 使用刚指定的配置项和数据显示图表。
        consumptionEchart.setOption(option)
      }, 500)
    }
  }
  //碳排放趋势折叠柱状图
  initConsumptionBar(dataX: any, dataY: any, id: number) {
    if (dataY.length > 0) {
      this.isshowdataListBar = true
      setTimeout(function () {
        const main: any = document.getElementById('carbonEmissionTrend')
        main.removeAttribute('_echarts_instance_')
        // 基于准备好的dom，初始化echarts实例
        const consumptionEchart: any = echarts.init(main as HTMLDivElement)
        // 指定图表的配置项和数据
        const option = {
          tooltip: {
            trigger: 'axis',
          },
          legend: {
            itemWidth: 15,
            itemHeight: 15,
            bottom: 0,
          },
          xAxis: {
            data: dataX,
            splitLine: {
              show: false,
            },
          },
          yAxis: {
            splitLine: {
              show: false,
            },
          },
          series:dataY,
        }
        // 使用刚指定的配置项和数据显示图表。
        consumptionEchart.setOption(option, true)
      }, 500)
    } else {
      this.isshowdataListBar = false
    }
  }
  //二氧化碳排放概括和环形图
  initConsumptionCO(dataY: any, id: number) {
    if (dataY.length > 0) {
      const main: any = document.getElementById('carbonEmissionCO')
      main.removeAttribute('_echarts_instance_')
      // 基于准备好的dom，初始化echarts实例
      const consumptionEchart: any = echarts.init(main as HTMLDivElement)
      // 指定图表的配置项和数据
      const option = {
        title: {
          show: true,
          text: '全部',
          subtext: id,
          top: '41%',
          left: '49%',
          textAlign: 'center',
          textStyle: {
            fontSize: '12',
            fontWeight: 'bold',
          },
          subtextStyle: {
            fontSize: '12',
            fontWeight: 'bold',
          },
        },
        tooltip: {
          show: true,
          trigger: 'item',
            //   formatter: '{a} <br/>{b}: {e} ({d}%)',
            formatter:function(data:any){
              return data.name + '<br/>'+ data.name+ ' : ' + data.data.dataValue + ' ('+data.percent.toFixed(1)+'%)'
            }
        },
        legend: {
          bottom: -5,
          left: 'center',
        },
        series: [
          {
            name: '二氧化碳排放量',
            type: 'pie',
            radius: ['35%', '50%'],
            itemStyle: {
              normal: {
                label: {
                  //此处为指示线文字
                  show: true,
                  // position: 'inner', //标签的位置
                  textStyle: {
                    fontWeight: 200,
                    fontSize: 13, //文字的字体大小
                  },
                  formatter: function (p: any) {
                    //指示线对应文字
                    return p.name.length>1?p.name.substr(0,1)+'...':p.name + Number(p.percent).toFixed(2) + '%'
                  },
                },
                labelLine: {
                  //指示线状态
                  show: true,
                  smooth: 0.2,
                  length: 10,
                },
              },
            },
            avoidLabelOverlap: false,
            label: {
              show: false,
              position: 'center',
            },
            emphasis: {
              label: {
                show: true,
                // fontSize: '10',
                // fontWeight: 'bold'
              },
            },
            labelLine: {
              show: false,
            },
            data: dataY,
          },
        ],
      }
      // 使用刚指定的配置项和数据显示图表。
      consumptionEchart.setOption(option)
    }
  }
  //二氧化碳排放趋势折叠柱状图
  initConsumptionBarCarborn(dataX: any, dataY: any, id: number) {
    if (dataY.length > 0) {
      this.isshowdataListBarCO = true
      const main: any = document.getElementById('carbonEmissionTrendCO')
      main.removeAttribute('_echarts_instance_')
      // 基于准备好的dom，初始化echarts实例
      const consumptionEchart: any = echarts.init(main as HTMLDivElement)
      // 指定图表的配置项和数据
      const option = {
        tooltip: {
          trigger: 'axis',
        },
        legend: {
          itemWidth: 15,
          itemHeight: 15,
          bottom: 0,
        },
        xAxis: {
          data: dataX,
          splitLine: {
            show: false,
          },
        },
        yAxis: {
          splitLine: {
            show: false,
          },
        },
        series: dataY,
      }
      // 使用刚指定的配置项和数据显示图表。
      consumptionEchart.setOption(option)
    } else {
      this.isshowdataListBarCO = false
    }
  }
  created() {
    if (this.$route.query.encode) {
      this.code = this.$route.query.encode.toString()
      this.action = this.$route.query.action.toString()
      this.riseObj.aboveDate = this.$route.query.year
      this.riseObj.belowDate =String(this.riseObj.aboveDate - 1) 
      this.riseObjCO.aboveDate = this.$route.query.year
      this.riseObjCO.belowDate = String(this.riseObj.aboveDate - 1)
      const params = {
        enterpriseCode: this.code,
        statDate: this.riseObj.aboveDate,
        emissionType: 0,
      }
      const that = this
      setTimeout(function () {
        that.init(params)
      }, 500)
    }
  }
}
